import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { FormActionsMui } from '@app/components/form/actions/FormActionsMui';
import { Stack } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import { ReactNode } from 'react';
import { FieldValues } from 'react-hook-form';
import { FormContainer } from 'react-hook-form-mui';
import { defineMessage, useIntl } from 'react-intl';
import { ZodTypeAny } from 'zod';

const defaultValuesSectionTitle = defineMessage({
  id: 'socialExport.form.defaultValuesUploads',
  defaultMessage: 'Valores por defecto para uploads',
});

type PlatformSettingsFormShellProps<T extends FieldValues> = {
  values: T;
  schema: ZodTypeAny;
  onSuccess: (data: T) => Promise<void>;
  children: ReactNode;
  /** Override the default "Valores por defecto para uploads" section title. */
  sectionTitle?: ReactNode;
};

/**
 * Shared shell for platform connection settings forms:
 * FormContainer + default-values section + cancel actions.
 */
export function PlatformSettingsFormShell<T extends FieldValues>({
  values,
  schema,
  onSuccess,
  children,
  sectionTitle,
}: PlatformSettingsFormShellProps<T>) {
  const { $t } = useIntl();

  return (
    <FormContainer
      mode="onBlur"
      values={values}
      onSuccess={onSuccess}
      resolver={zodResolver(schema)}
    >
      <ContentCluster title={sectionTitle ?? $t(defaultValuesSectionTitle)}>
        <Stack spacing={4}>{children}</Stack>
      </ContentCluster>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
